import { Slider, Title, Text, Divider, Paper } from "@mantine/core";
import { useState } from "react";
import { EQUALIBRIUM } from "./utils";

export const getRatingGain = (
    rating: number,
    engineLevel: number,
    evaluation: number,
    playerColor: "w" | "b",
    k = 64,
    equalibrium = EQUALIBRIUM,
    c = 1600
) => {
    // console.log('new eval:', evaluation)

    // rating difference + eval -> rating increase
    // max eval: k points rewarded
    // max eval: +4
    // easing function
    // nullpunkt: 0.25
    // sqrt(x) * 16 = f(x)

    const INITIAL_EVAL = equalibrium;
    let ratingGain = Math.min((k / 2) * Math.abs(evaluation - INITIAL_EVAL) ** 0.5, k);

    if (playerColor === "w" && evaluation < INITIAL_EVAL) {
        ratingGain *= -1;
    }
    if (playerColor === "b" && evaluation > INITIAL_EVAL) {
        ratingGain *= -1;
    }

    const STANDARD_DEV = c; // Normally 400
    const expectedScore = 1 / (1 + 10 ** ((rating - engineLevel) / STANDARD_DEV));
    const result = Math.round(ratingGain * expectedScore);
    return result;
};

const RatingCalculator = () => {
    const [equalibrium, setEqualibrium] = useState(EQUALIBRIUM);
    const [kFactor, setKFactor] = useState(64);
    const [c, setC] = useState(1600);

    const [whiteRating, setWhiteRating] = useState(1600);
    const [blackRating, setBlackRating] = useState(1600);
    const [ev, setEv] = useState(0.3);

    const ratingGain = getRatingGain(whiteRating, blackRating, ev, "w", kFactor, equalibrium, c);

    return (
        <div>
            <Title mb="4rem">Rating gain calculator</Title>

            <div className="flex items-center space-x-16 w-[800px]">
                <div className="w-full">
                    <Slider value={equalibrium} onChange={setEqualibrium} labelAlwaysOn step={0.05} max={0.6} />
                    <Text size="sm">Equalibrium</Text>
                </div>

                <div className="w-full">
                    <Slider value={kFactor} onChange={setKFactor} labelAlwaysOn max={200} />
                    <Text size="sm">kFactor</Text>
                </div>

                <div className="w-full">
                    <Slider value={c} onChange={setC} labelAlwaysOn max={2000} step={100} />
                    <Text size="sm">C</Text>
                </div>
            </div>
            <Divider my="xl" />
            <div className="mt-20">
                <div className="flex items-center justify-start w-[800px]">
                    <div className="w-[60%]">
                        <div className="w-full">
                            <Slider
                                value={whiteRating}
                                onChange={setWhiteRating}
                                labelAlwaysOn
                                min={1200}
                                max={2200}
                                step={50}
                            />
                            <Text size="sm">White rating</Text>
                        </div>
                        <div className="mt-12 w-full">
                            <Slider
                                value={blackRating}
                                onChange={setBlackRating}
                                labelAlwaysOn
                                min={1200}
                                max={2200}
                                step={50}
                            />
                            <Text size="sm">Black rating</Text>
                        </div>
                        <div className="mt-12 w-full">
                            <Slider value={ev} onChange={setEv} labelAlwaysOn min={-1} max={5} step={0.1} />
                            <Text size="sm">Eval</Text>
                        </div>
                    </div>
                    <div className="ml-32">
                        <Paper withBorder w="100px" h="100px">
                            <Text mt="1.5rem" fz="h2" c={ratingGain >= 0 ? "green" : "red"}>
                                {ratingGain >= 0 ? `+${ratingGain}` : ratingGain}{" "}
                            </Text>
                        </Paper>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RatingCalculator;
